import {AppRouter} from '@/routes/AppRouter'
import {DEFAULT_INTL} from '@/shared/constants/globalConstants'
import {AuthProvider} from '@/context/Auth/AuthProvider'
import useInternationalization from '@/internationalization/useInternationalization'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {IntlProvider} from 'react-intl'
import './assets/scss/App.scss'
import {store, persistor} from '@/store'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {ThemeProvider} from '@pepsico-ds/ui'
import {UIThemeProvider} from '@/context/UITheme/UIThemeContext'
import {isFeatureEnabledByDefault} from '@/shared/config/featureToggle'
import {FeatureToggleDefaultEnabled} from '@/shared/constants/featuresFlag'
import {MsalProvider} from '@azure/msal-react'
import {msalInstance} from '@/shared/config/msalConfig'
import PropTypes from 'prop-types'

const DS_THEME_STYLE = isFeatureEnabledByDefault(FeatureToggleDefaultEnabled.modernUI)
  ? 'Dark PepsiConnect'
  : 'Dark Peacock'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})

function App({shellActive = false, darkTheme = false, path = '', market}) {
  const [language, message] = useInternationalization(DEFAULT_INTL)
  return (
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <IntlProvider locale={language} messages={message}>
              <AuthProvider shellActive={shellActive}>
                <ThemeProvider defaultStyle={DS_THEME_STYLE}>
                  <UIThemeProvider>
                    <AppRouter shellActive={shellActive} darkTheme={darkTheme} path={path} market={market} />
                  </UIThemeProvider>
                </ThemeProvider>
              </AuthProvider>
            </IntlProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </MsalProvider>
  )
}

export default App

App.propTypes = {
  shellActive: PropTypes.bool,
  darkTheme: PropTypes.bool,
  path: PropTypes.string,
  market: PropTypes.string,
}
